import { Grid, useMediaQuery, useTheme } from "@material-ui/core";
import { Block, Save } from "@material-ui/icons";
import CommonButton from "app/common/Component/Button/CommonButton";
import PopupForm from "app/common/Component/Popup/PopupForm";
import { useFormikContext } from "formik";
import { observer } from "mobx-react";
import React, { memo, useRef } from "react";
import { useReactToPrint } from "react-to-print";
import RegisterProductPrintContent from "./RegisterProductPrintContent";

function RegisterProductPreviewPrintPopup(props) {
    const {
        patient,
        handleClose,
        open
    } = props;

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
    const componentRef = useRef();

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: "In phiếu",
    });

    return (
        <PopupForm
            open={open}
            size="xxl"
            height="75vh"
            handleClose={handleClose}
            title={"In phiếu "}
            formik={{
                initialValues: {},
                onSubmit: async (values) => {
                    console.log("Data", values);
                },
                enableReinitialize: true,
            }}
            action={(values) => {
                return (
                    <div className="flex-center gap-1">
                        <CommonButton type="submit" onClick={handlePrint}>
                            {!isMobile && <Save className="mr-2 " />}
                            In phiếu
                        </CommonButton>

                        <CommonButton className="btn-gray" onClick={handleClose} >
                            <Block className="mr-2" /> Đóng
                        </CommonButton>
                    </div>
                );
            }}
        >
            {({ setFieldValue, values }) => {
                return (
                    <>
                        <ValueForm
                            componentRef={componentRef}
                            patient={patient}
                        />
                    </>
                );
            }}
        </PopupForm>
    );
};

const ValueForm = observer((props) => {
    const {
        componentRef,
        patient

    } = props;

    console.log("patient", patient);

    const {
        values,
        setFieldValue
    } = useFormikContext();

    return (
        <>
            <Grid container spacing={1}>
                {/* <Grid item xs={6}>
          <GlobitsSelectInput
            label="Loại mẫu phiếu"
            name="methodPrint"
            options={FORM_PRINT}
          />
        </Grid> */}
                <Grid
                    item
                    xs={12}
                    className="flex-center"
                    style={{ border: "1px dashed black", margin: "5px" }}
                >
                    {/* <FormPrintTreatmentPlanTab /> */}
                    <RegisterProductPrintContent
                        componentRef={componentRef}
                        patient={patient}
                    />

                </Grid>

            </Grid>
        </>
    );
});

export default memo(observer(RegisterProductPreviewPrintPopup));
